import { fetchPosts } from '$c3social/fetch-posts.js';

const batchSize = 8;
let offset = batchSize;

export function initSocials() {
    $('.socials-load-more').click(async function () {
        const container = $(this).parents('.tx-c3social');
        const parentId = container.parent().attr('id');
        const contentUid = parseInt(parentId.substring(1, parentId.length));

        $(this).addClass('disabled');

        const res = await fetchPosts(batchSize, contentUid, offset, true);
        const html = await res.text();

        const posts = $(html);
        container.find('.row').append(html);

        $(this).removeClass('disabled');

        if (posts.length < batchSize) {
            $(this).parent().remove();
        }

        offset += batchSize;
    });
}